var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-megjelenito-wrapper"},[_c('iframe',{staticClass:"iframe-megjelenito",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }